import { Link, LinkProps } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { LabelV2Version } from 'types/releases';
import { useReleaseCallbackUrl } from '../ReleaseActions';

interface GoToSongProps extends LinkProps {
  tab: 'details' | 'contributions' | 'lyrics' | 'splits';
  focus?: string;
  releaseVersion?: LabelV2Version;
}

export const GoToSong = ({
  focus,
  tab = 'details',
  releaseVersion,
  ...rest
}: GoToSongProps) => {
  const releaseCallbackUrl = useReleaseCallbackUrl(tab, releaseVersion);
  const focusQueryParam = focus ? `&focus=${focus}` : '';

  return (
    <Link
      as={RouterLink}
      to={`${releaseCallbackUrl}${focusQueryParam}`}
      color="B.80"
      fontWeight={500}
      textDecoration="none"
      {...rest}
    >
      Go to Song
    </Link>
  );
};
